<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17Drvlg/tc-custom/9783956764516_IMGJPG_FrontCover_0.jpg" alt="This image is the cover for the book A Man of Means, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Man of Means, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>“A Man of Means” is a collection of short stories written in collaboration by P. G. Wodehouse and C. H. Bovill. (Excerpt from Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P. G. Wodehouse
      </h2>
      
      <p class="authorDescription body article">Sir Pelham Grenville Wodehouse KBE (15 October 1881 – 14 February 1975) was an English author and one of the most widely read humorists of the 20th century. Born in Guildford, the third son of a British magistrate based in Hong Kong, Wodehouse spent happy teenage years at Dulwich College, to which he remained devoted all his life. After leaving school, he was employed by a bank but disliked the work and turned to writing in his spare time. His early novels were mostly school stories, but he later switched to comic fiction, creating several regular characters who became familiar to the public over the years. They include the jolly gentleman of leisure Bertie Wooster and his sagacious valet Jeeves; the immaculate and loquacious Psmith; Lord Emsworth and the Blandings Castle set; the Oldest Member, with stories about golf; and Mr Mulliner, with tall tales on subjects ranging from bibulous bishops to megalomaniac movie moguls. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c9fd1b5a